import React from "react";

const Oeffnungszeiten = () => (
  <div>
    <h3>Öffnungszeiten</h3>
    <p>
      Di, Mi, Do <br />
      17:00 bis 22:00 Uhr
      <br />
      Fr, Sa und So <br />
      11:30 Uhr bis 14:30 Uhr & 17:00 bis 22:00 Uhr
      <br />
      Montag Ruhetag
      <br />
    </p>
  </div>
);

export default Oeffnungszeiten;
